import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-w', 'LetterW', [["path",{"d":"M4 4l4 16l4 -14l4 14l4 -16","key":"svg-0"}]]);